import { createKey } from './createKey';

export interface ListImportsParams {
  pg?: number;
  rc?: number;
  status?: string;
}

export interface ListRowsParams {
  pg?: number;
  rc?: number;
  status?: string;
  stage?: string;
}

export interface ListTemplatesParams {
  owner?: 'all' | 'system' | 'company';
  search?: string;
}

const keyHandler = createKey('bulk-import');

export const BulkImportServiceKeys = {
  key: keyHandler.key,
  listImports: keyHandler.createMethod<ListImportsParams>(),
  getImport: keyHandler.createMethod<{ guid: string }>(),
  getImportStats: keyHandler.createMethod<{ guid: string }>(),
  listImportRows: keyHandler.createMethod<{ guid: string } & ListRowsParams>(),
  listTemplates: keyHandler.createMethod<ListTemplatesParams | void>(),
  getTemplate: keyHandler.createMethod<{ id: string }>(),
  getTargetFields: keyHandler.createMethod(),
};
